import React from 'react'
import { Button, Figure } from 'react-bootstrap'
import { IoMdRefresh } from 'react-icons/io'
import image1 from "../Images/01.jpg";
import image2 from "../Images/02.jpg";
import image3 from "../Images/03.jpg";
import image4 from "../Images/04.jpg";
import image5 from "../Images/05.jpg";
import image6 from "../Images/06.jpg";
import image7 from "../Images/07.jpg";
import image8 from "../Images/1.jpg";
import image9 from "../Images/image3.jpg";

const MyList = () => {
    const images = [image1, image2, image3, image4, image5, image6, image7, image8, image9];
    return (
        <>
            <div className="px-2">
                <span className="text_light fw-bold fs-30">My List</span>
            </div>
            <div className="editable-see-more mb-5">
                <span className='text_light fw-bold fs-18'>You haven't added anything in My List.</span>
            </div>
            <div className="px-5">
                <div className="hstack justify-content-between w-100 mb-4">
                    <span className="text_light fw-bold fs-18">Recommendation</span>
                    <Button variant="dark" ><IoMdRefresh className="mx-2" />Refresh</Button>
                </div>
                <div className="hstack gap-3">
                    {images?.map((image, index) => (
                        <Figure key={index}>
                            <Figure.Image
                                width={171}
                                height={180}
                                alt={`Image ${index + 1}`}
                                src={image}
                                className="zoom rounded"
                            />
                        </Figure>
                    ))}
                </div>
            </div>
        </>
    )
}

export default MyList